import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { ContentManager } from '@vfgroup-oneplatform/foundation';
import { SectionHeader, VFButton, VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import ManualRefresh from '@vfgroup-oneplatform/foundation/Components/ManualRefresh';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';
import Timeline from '../../Components/Timeline/Timeline';

import OrderProgressProps from './OrderProgress.context';
import styles from './OrderProgress.styles';

class OrderProgress extends Component {
  constructor(props) {
    super(props);

    this.headerRef = React.createRef();
    this.images = getThemeImages(this.props.theme.name);

    this.state = {
      activeStep: {},
      activeStepIndex: -1,
    };
  }

  static getDerivedStateFromProps(props) {
    const stepFinder = step => step.key === props.orderData.orderStatus;

    const activeStep = props.timeline.find(stepFinder) || {};
    const activeStepIndex = props.timeline.findIndex(stepFinder);

    return { activeStep, activeStepIndex };
  }

  getVFScreenStringProps = () => ({
    title: ContentManager.translate('order_progress_screen_title', [this.props.orderData.id]),

    withSubHeader: true,
    subHeaderTitle: ContentManager.translate('order_progress_status', [
      ContentManager.translate(this.state.activeStep.title || ''),
    ]),
    subHeaderTitleStyle: styles.subHeaderTitle,

    subHeaderSubTitle: ContentManager.translate('order_progress_estimated_delivery', [
      this.props.orderData.deliveryDate,
    ]),
    subHeaderSubTitleStyle: styles.subHeaderSubTitle,

    subHeaderDescription: this.props.orderAccount,
    renderDescriptionInfo: this.renderManualRefresh,
  });

  renderManualRefresh = () => {
    return (
      <ManualRefresh
        images={this.images}
        lastUpdateTime={this.props.lastUpdateTime}
        onRefresh={this.props.onRefresh}
        containerStyle={styles.container}
      />
    );
  };

  render() {
    return (
      <VFScreen
        ref={this.headerRef}
        showBack
        onBack={this.props.onBack}
        onClose={this.props.onClose}
        {...this.getVFScreenStringProps()}
        withHeaderSpace
        configureHeaderTabs={{}}
        contentContainerStyle={styles.contentContainer}
      >
        <OrderProgressProps.Provider value={this.props}>
          <VFButton
            title="order_progress_alert_button"
            onPress={() => {}}
            style={styles.VFButton}
          />

          <SectionHeader
            theme={this.props.theme}
            title="order_progress_timeline_title"
            rightText="order_progress_timeline_action"
            rightTextStyle={styles.rightText}
            rightIcon={this.images.icon_bill_report_generic}
            subtitle={ContentManager.translate('order_progress_timeline_subtitle', [
              this.props.orderData.placedDate,
            ])}
            subtitleStyle={styles.subtitle}
          />

          <Timeline activeStepIndex={this.state.activeStepIndex} />
        </OrderProgressProps.Provider>
      </VFScreen>
    );
  }
}

OrderProgress.defaultProps = {
  theme: LightThemeColors,
};

OrderProgress.propTypes = {
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  lastUpdateTime: PropTypes.any,
  onRefresh: PropTypes.func,
  orderAccount: PropTypes.string.isRequired,
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      primaryButton: PropTypes.shape({
        title: PropTypes.string.isRequired,
        onPress: PropTypes.func.isRequired,
      }),
      secondaryButton: PropTypes.shape({
        title: PropTypes.string.isRequired,
        onPress: PropTypes.func.isRequired,
      }),
    }),
  ).isRequired,
  orderData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    orderStatus: PropTypes.string.isRequired,
    deliveryDate: PropTypes.string.isRequired,
    placedDate: PropTypes.string.isRequired,
    updateDate: PropTypes.string.isRequired,
    updateTime: PropTypes.string.isRequired,
  }).isRequired,
  theme: PropTypes.object,
};

export default withTheme(OrderProgress);
